
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summary",
      function () {
        return require("private-next-pages/summary.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summary"])
      });
    }
  